module.exports = __webpack_public_path__ + "media/images/AsianLife-e01ad5f17a223394545f1fb810a2d89e.png";